import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import LocationSelectNoAll from '../general/LocationSelectNoAll.js'

class PatronCountsForm extends React.Component {
  state = {
    zones: [],
    currentDayOfWeek: moment().format('dddd').toLowerCase(),
    selectedLocationId: parseInt(this.props.locationId),
    createdAt: new Date(),
    loaded: false,
    errorMessage: null,
    saveDisabled: true
  }

  getZones() {
    var that = this
    var params = {
      day: this.state.currentDayOfWeek,
      order_by: 'priority',
      order_dir: 'ASC'
    }

    if (this.state.selectedLocationId) {
      params['location_id'] = this.state.selectedLocationId
    }

    axios({
      method:'get',
      url:'/zones.json',
      params: params,
      responseType:'json'
    })
    .then(function(response) {
      that.setState({ zones: response.data }, () => { that.checkDisabled() })
      that.setState({ loaded: true })
    })
    .catch(({ response }) => {
      let errorMessage = null;
      if (response && response.data && response.data.message) {
        errorMessage = response.data.message;
      }
      that.setState({ zones: [], errorMessage });
    });
  }

  componentDidMount() {
    var that = this
    var createdAtPicker = $('#createdAtPicker').data('kendoDateTimePicker')

    if (createdAtPicker) {
      createdAtPicker.value(null)
    }

    $('#createdAtPicker').kendoDateTimePicker({
        value: new Date(),
        dateInput: true
    })

    $('#createdAtPicker').kendoDateTimePicker({
      change: function(e) {
        var value = e.sender.value()

        that.setState({
          createdAt: value,
          currentDayOfWeek: moment(value).format('dddd').toLowerCase()
        })

        if (value) {
          toastr.error('Date changed, please re-enter patron counts');
        }
        that.getZones()
      }
    })

    this.getZones()
  }

  newLocation(newLocation) {
    this.setState({ selectedLocationId: newLocation })
    this.getZones()
  }

  save = () => {
    var that = this
    var patronCounts = []

    _.forEach(this.state.zones, function(zone) {
      patronCounts.push(
        {
          zone_id: zone.id,
          user_id: that.props.currentUser.id,
          count: zone.count,
          created_at: that.state.createdAt
        }
      )
    })

    axios.post('/patron_counts', {
      data: patronCounts
    })
    .then(function (response) {
      toastr.success('Patron counts created')
      setTimeout(function() { Turbolinks.visit('/patron_counts') }.bind(that), 800)
    })
    .catch(function (error) {
      toastr.error('Patron counts not created')
      console.log(error)
    })
  }

  handleCountChange = (e, zone, index) => {
    var that = this
    var zones = this.state.zones
    var count = e.target.value

    if (count && /^\d+$/.test(count)) {
      zone.count = count
    }
    else {
      zone.count = ''
    }

    this.checkDisabled();
    zones[index] = zone
    this.setState({ zones: zones })
  }

  checkDisabled = () => {
    const allZoneInputs = $('[title="Zones"]')

    if(allZoneInputs.length === 0) {
      this.setState({saveDisabled: true});
      return;
    }

    let saveDisabled = true
    _.each(allZoneInputs, (zoneInput) => {
      if (zoneInput.value.trim().length !== 0) {
        saveDisabled = false;
      }
    })

    if (saveDisabled !== this.state.saveDisabled) {
      this.setState({ saveDisabled })
    }
  }

  renderZones() {
    var that = this

    var zoneFormElements = this.state.zones.map((zone, index) => {
      return(
        <div key={index}>
          <div className='form-group'>
            <label>{zone.name}</label>
            <input className='form-control'
                   title='Zones'
                   type='number'
                   value={zone.count || ''}
                   onChange={(e) => that.handleCountChange(e, zone, index)} />
          </div>
        </div>
      )
    })

    if (this.state.zones.length > 0) {
      return(
        <div>{ zoneFormElements }</div>
      )
    }
    else {
      return(
        <p className='center-text pink-text'>
          {that.state.errorMessage || "No zones configured on this day"}
          <br />
          <br />
        </p>
      )
    }
  }

  renderSaveButton() {
    var that = this

    return(
      <button type='button'
        className='btn btn-pink full-width'
        disabled={this.state.saveDisabled}
        onClick={function(){ that.save() }}
      >
        SAVE
      </button>
    )
  }

  render() {
    var that = this

    return(
      <div>
        <h1>
          New Patron Count
        </h1>
        <div className='u-form-width-fix well shadowDepth1'>
          <label>
            Location
          </label>
          <LocationSelectNoAll
            locationId={this.state.selectedLocationId}
            locations={this.props.locations}
            newLocationCallback={(newLocation) => this.newLocation(newLocation) }/>
          <label>
            Date
          </label>
          <br />
          <input id='createdAtPicker'
                 placeholder='dd/mm/yyyy'
                 className='full-width' />
          <br />
          <hr />
          <div>
            {that.state.loaded ? (
              <div>
                {that.renderZones()}
              </div>
            ) : (
              <center>
                Loading...
                <br />
                <br />
              </center>
            )}
          </div>

          {that.renderSaveButton()}
        </div>
      </div>
    )
  }
}

PatronCountsForm.propTypes = {
  patronCount: PropTypes.object,
  locationId: PropTypes.string,
  currentUser: PropTypes.object,
  locations: PropTypes.array
}

export default PatronCountsForm
